

// import React from "react";
// import "../styles/contact.css";

// function Contact() {
//   return (
//     <>
//       {/* PAGE HEADER */}
//       <section className="contact-hero">
//         <div className="container">
//           <h1>Contact / Inquiry</h1>
//           <p>
//             Reach out to us for industrial product inquiries and business
//             partnerships.
//           </p>
//         </div>
//       </section>

//       {/* CONTACT SECTION */}
//       <section className="contact-page">
//         <div className="container contact-grid">

//           {/* FORM */}
//           <div className="contact-form">
//             <h3>Send Us an Inquiry</h3>

//             <form
//               action="https://formspree.io/f/REPLACE_WITH_YOUR_ID"
//               method="POST"
//             >
//               <div className="form-group">
//                 <input type="text" name="name" placeholder="Your Name" required />
//               </div>

//               <div className="form-group">
//                 <input type="text" name="company" placeholder="Company Name" />
//               </div>

//               <div className="form-group">
//                 <input type="email" name="email" placeholder="Email Address" required />
//               </div>

//               <div className="form-group">
//                 <input type="tel" name="phone" placeholder="Phone Number" />
//               </div>

//               <div className="form-group">
//                 <textarea
//                   name="message"
//                   rows="4"
//                   placeholder="Your Message"
//                   required
//                 ></textarea>
//               </div>

//               <button type="submit" className="btn btn-primary">
//                 Submit Inquiry
//               </button>
//             </form>
//           </div>

//           {/* CONTACT INFO + MAP */}
//           <div className="contact-info">
//             <h3>Contact Information</h3>

//             <p>
//               <i className="fa fa-map-marker"></i>
//               Ras Al Khaimah, United Arab Emirates
//             </p>

//             <p>
//               <i className="fa fa-phone"></i>
//               +971 58 573 5792
//             </p>

//             <p>
//               <i className="fa fa-envelope"></i>
//               info@apextrade.ae
//             </p>

//             {/* MAP */}
//             <div className="contact-map">
//               <iframe
//                 title="Apex Trade Location"
//                 src="https://www.google.com/maps?q=Ras%20Al%20Khaimah,%20UAE&output=embed"
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//               ></iframe>
//             </div>
//           </div>

//         </div>
//       </section>
//     </>
//   );
// }

// export default Contact;

import React, { useState } from "react";
import "../styles/contact.css";

function Contact() {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const res = await fetch("https://apextrade.ae/node-server/api/send-inquiry", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });

      if (res.ok) {
        setStatus("success");
        e.target.reset();
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* PAGE HEADER */}
      <section className="contact-hero">
        <div className="container">
          <h1>Contact / Inquiry</h1>
          <p>
            Reach out to us for industrial product inquiries and business
            partnerships.
          </p>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="contact-page">
        <div className="container contact-grid">

          {/* FORM */}
          <div className="contact-form">
            <h3>Send Us an Inquiry</h3>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input type="text" name="name" placeholder="Your Name" required />
              </div>

              <div className="form-group">
                <input type="text" name="company" placeholder="Company Name" />
              </div>

              <div className="form-group">
                <input type="email" name="email" placeholder="Email Address" required />
              </div>

              <div className="form-group">
                <input type="tel" name="phone" placeholder="Phone Number" />
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  rows="4"
                  placeholder="Your Message"
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? "Sending..." : "Submit Inquiry"}
              </button>

              {status === "success" && (
                <p className="form-success">
                   Inquiry sent successfully. We’ll get back to you soon.
                </p>
              )}

              {status === "error" && (
                <p className="form-error">
                   Something went wrong. Please try again later.
                </p>
              )}
            </form>
          </div>

          {/* CONTACT INFO + MAP */}
          <div className="contact-info">
            <h3>Contact Information</h3>

            <p>
              <i className="fa fa-map-marker"></i>
              Ras Al Khaimah, United Arab Emirates
            </p>

            <p>
              <i className="fa fa-phone"></i>
              +971 58 573 5792
            </p>

            <p>
              <i className="fa fa-envelope"></i>
              info@apextrade.ae
            </p>

            {/* MAP */}
            <div className="contact-map">
              <iframe
                title="Apex Trade Location"
                src="https://www.google.com/maps?q=Ras%20Al%20Khaimah,%20UAE&output=embed"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default Contact;
